export enum WorkshopStatus {
  WORKSHOP_STATUS_FEE_APPROVAL_PENDING = "FEE_APPROVAL_PENDING",
  WORKSHOP_STATUS_PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  WORKSHOP_STATUS_CONFIRMED = "CONFIRMED",
  WORKSHOP_STATUS_PROPOSED = "PROPOSED",
  WORKSHOP_STATUS_DONE = "DONE"
}
